import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';
import { createTheme } from '@material-ui/core';

export const customTheme = createTheme({
  palette: {
    primary: {
      main: '#b12321', //hardcoding color
    },
  },
  buttons: {
    mainBtn: {
      backgroundColor: '#b12321',
    },
    mainBtnHover: {
      backgroundColor: '#b12321',
      opacity: 0.7,
    },
  },
});

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    /* component styling to override */
  });
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
